import React, {useEffect} from 'react';
import { FaLinkedinIn, FaGithub, FaTwitterSquare } from 'react-icons/fa'
import AOS from 'aos'
import 'aos/dist/aos.css';

const HeaderSocials = () => {
    useEffect(() => {
    AOS.init({duration: 800})
  }, []);
  return (
    <div className='header-socials' data-aos="fade-down" data-aos-anchor-placement="top-bottom" data-aos-delay="1300">
      <a href="https://www.linkedin.com/in/mussagy-remane-9b8a59141/" target='_black' rel="noopener noreferrer" data-aos="fade-down" data-aos-anchor-placement="top-bottom" data-aos-delay="1600"><FaLinkedinIn /></a>
      <a href="https://github.com/Miargy6" target='_black' rel="noopener noreferrer" data-aos="fade-down" data-aos-anchor-placement="top-bottom" data-aos-delay="1500"><FaGithub /></a>
      <a href="https://twitter.com/mussagy_remane" target='_black' rel="noopener noreferrer" data-aos="fade-down" data-aos-anchor-placement="top-bottom" data-aos-delay="1400"><FaTwitterSquare/></a>
    </div>
  );
}

export default HeaderSocials;
